import { CalendarIcon } from 'app/agriculture/icons';
import './MonthIcon.scss';

interface MonthIconProps {
    // The month number or string to display inside the icon
    month?: number | string;
}

export function MonthIcon({ month }: MonthIconProps) {
    return (
        <div className="MonthIcon" data-month={month}>
            <CalendarIcon size={20} />
        </div>
    );
}
